/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import prepareBrand from "@DSG/Overrides/Store/Components/ProductRecommendations/Handlers/PrepareBrand";
import { createFromProduct } from "@insite/client-framework/Common/ProductInfo";
import { addToChainAfter, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import prepareCategory from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareCategory";
import prepareSearchResultPage from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareSearchResultPage";

import {
    chain,
    ParseQueryParameter,
    PrepageProductRecs,
    SetUpProductInfos,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import qs from "qs";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

export const ParseQueryParameterExt = (props: any)=> {
    const { queryString } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString);

    const { stockedMyBranch, brandIds, isFirst,attributeValueIds } = parsedQuery;
    
    const { catalogPage } = props.result;
    let newBrandIds  = props.result?.productFilters?.brandIds;   
    let isdsgFilter:boolean =  isFirst;
    let newAttributeValueIds = props.result?.productFilters?.attributeValueIds;

    if(brandIds === undefined){
        if(newBrandIds === undefined && catalogPage?.properties?.brandId !== undefined && isFirst === undefined){
            newBrandIds = [catalogPage?.properties?.brandId];
            isdsgFilter = true;
        }
    }
    if(attributeValueIds === undefined){
        if(catalogPage?.properties?.attributeId !== undefined && isFirst === undefined){
            newAttributeValueIds = [catalogPage?.properties?.attributeId]; 
            isdsgFilter = true;
        }
    }

    props.result.productFilters = {
        ...props.result.productFilters,
        brandIds: newBrandIds,
        isFirst: isdsgFilter !== undefined? isdsgFilter : undefined,
        attributeValueIds: newAttributeValueIds,
        stockedMyBranch: stockedMyBranch !== undefined ? stockedMyBranch === "true" : undefined,
    };
};
addToChainAfter(chain, ParseQueryParameter, ParseQueryParameterExt);

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
replaceInChain(chain,
    SetUpProductInfos ,
    props => {

        props.idByPath = {};
    
        props.result.products?.forEach(product => {
            if (props.result.productInfosByProductId[product.id]) {
                return;
            }
    
            const productDetailPath = product.canonicalUrl;
            props.idByPath![productDetailPath] = product.id;
            props.result.productInfosByProductId[product.id] = {
                ...createFromProduct(product),
                productDetailPath,
            };
        });

    },
 );

 replaceInChain(chain, PrepageProductRecs,  
    ({
        getState,
        dispatch,
        parameter: { isSearch },
        result: { catalogPage, products },
    }) => {
        const state = getState();

        if (catalogPage && !isSearch && !catalogPage.brandId) {
            dispatch(prepareCategory({ catalogPage }));
        }
    
        if (products) {
            if (isSearch) {
                const pagination = getProductListDataViewProperty(state, "pagination");
                const attributeTypeFacets = getProductListDataViewProperty(state, "attributeTypeFacets");
                const originalQuery = getProductListDataViewProperty(state, "originalQuery");
                dispatch(prepareSearchResultPage({ products, pagination, attributeTypeFacets, originalQuery }));
            } else if (catalogPage && !isSearch && catalogPage.brandId) {
                const brandFacets = getProductListDataViewProperty(state, "brandFacets");
                if (brandFacets) {
                    dispatch(prepareBrand({ brandFacets }));
                }
            }
        }
   }
);
